import { API_URL } from '../../../app-config/constants';
import { Setting } from '../../react/features/Admin/FeatureSelection/types';
import { get, post } from '../request';

const FEATURE_SELECTION_SETTINGS_URL = `${API_URL}/admin/feature-selection/settings`;

export function getFeatureSelectionPage() {
    return get<Setting[]>(FEATURE_SELECTION_SETTINGS_URL);
}

export function getFeatureSelectionByCategory(featureCategory: string) {
    return get<Setting[]>(`${FEATURE_SELECTION_SETTINGS_URL}/${featureCategory}`);
}

export function postFeatureSelectionPage(request: Setting[]) {
    return post(FEATURE_SELECTION_SETTINGS_URL, { postData: request });
}
